import { render, staticRenderFns } from "./iossTaxRateSetting.vue?vue&type=template&id=0264ee6f&scoped=true"
import script from "./iossTaxRateSetting.vue?vue&type=script&lang=js"
export * from "./iossTaxRateSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0264ee6f",
  null
  
)

export default component.exports